import { render, staticRenderFns } from "./EntregaComprometimento.vue?vue&type=template&id=782d0528"
import script from "./EntregaComprometimento.vue?vue&type=script&lang=js"
export * from "./EntregaComprometimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports